import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e99c633"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "w-5 h-5 shrink-0"
}
const _hoisted_2 = { class: "flex gap-2 text-xs flex-1 min-w-0 my-1" }
const _hoisted_3 = {
  key: 0,
  class: "dates hidden items-center gap-1 min-w-0"
}
const _hoisted_4 = {
  key: 0,
  class: "rounded-lg px-2 py-0.5 text-white plannedBg truncate capitalize"
}
const _hoisted_5 = { class: "truncate" }
const _hoisted_6 = {
  key: 1,
  class: "rounded-lg px-2 py-0.5 text-white bg-green truncate ml-2 capitalize"
}
const _hoisted_7 = { class: "truncate" }
const _hoisted_8 = { class: "ml-4" }

import { Disclosure, DisclosureButton, DisclosurePanel } from "@headlessui/vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";
import { format } from "date-fns";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useTrackEvent } from "shared/composables/tracking";
import { HierarchyTagStore } from "shared/types/HierarchyTag";
import { ActualEvent, PlannedEvent, PlannerItemWithChildren } from "shared/types/Plan";
import { ShortenedProcessWithTags } from "shared/types/Process";
import { ProjectDurationSettings } from "shared/types/ProjectDurationSettings";
import { PlannerItemProgress } from "@/types/Plan";
import MarkAsDoneModal from "@/views/planner/components/MarkAsDoneModal.vue";
import ProjectProgressItemDetail from "@/views/planner/components/ProjectProgressItemDetail.vue";
import ProjectProgressItemName from "@/views/planner/components/ProjectProgressItemName.vue";
import { calculateEndDateDeviationWd } from "@/views/planner/planner";

const dateFormat = "dd.MM.yy";


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectProgressItem',
  props: {
    plannerItem: {},
    plannerItemProgressById: {},
    hierarchyTags: {},
    actualEventsBySourceId: {},
    plannedEventsByPlannerId: {},
    simplified: { type: Boolean },
    processesBySourceId: {},
    level: {},
    parentDefaultOpen: { type: Boolean },
    childrenCountByLevel: {},
    tagsByPlannerItemId: {},
    projectDurationSettings: {},
    totalProgress: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n();
const trackEvent = useTrackEvent();

const isMarkAsDoneModalOpen = ref(false);

const plannerItemProgress = computed(() => props.plannerItemProgressById[props.plannerItem._id]);

const tags = computed(() => props.tagsByPlannerItemId[props.plannerItem._id]);

const actualEventDates = computed(() => {
  const actualEvent = props.actualEventsBySourceId[props.plannerItem.source_id];
  if (!actualEvent) {
    return null;
  }
  if (!actualEvent.end) {
    return `${format(actualEvent.start, dateFormat)}-${t(
      "analytics.planner.present",
    ).toLowerCase()}`;
  }
  return `${format(actualEvent.start, dateFormat)}-${format(actualEvent.end, dateFormat)}`;
});

const plannedEvent = computed(() => props.plannedEventsByPlannerId[props.plannerItem._id]);

const plannedEventDates = computed(() => {
  if (!plannedEvent.value) {
    return null;
  }
  return `${format(plannedEvent.value.start, dateFormat)}-${format(
    plannedEvent.value.end,
    dateFormat,
  )}`;
});

const actualEvent = computed(() => props.actualEventsBySourceId[props.plannerItem.source_id]);

const childrenCountOnCurrentLevel = computed(() => props.childrenCountByLevel[props.level] || 0);

const isDefaultOpen = computed(
  () => props.parentDefaultOpen && childrenCountOnCurrentLevel.value < 100,
);

const endDateDeviationWd = computed(() =>
  calculateEndDateDeviationWd(plannedEvent.value, actualEvent.value, props.projectDurationSettings),
);

return (_ctx: any,_cache: any) => {
  const _component_ProjectProgressItem = _resolveComponent("ProjectProgressItem", true)!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Disclosure), { defaultOpen: isDefaultOpen.value }, {
      default: _withCtx(({ open }) => [
        _createVNode(_unref(DisclosureButton), { class: "flex gap-2 w-full items-center hover:bg-gray-100 px-2 item" }, {
          default: _withCtx(() => [
            (_ctx.plannerItem.children && _ctx.plannerItem.children.length > 0)
              ? (_openBlock(), _createBlock(_unref(ChevronRightIcon), {
                  key: 0,
                  class: _normalizeClass([{ 'rotate-90': open }, "w-5 h-5 shrink-0"])
                }, null, 8, ["class"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_1)),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(ProjectProgressItemName, {
                plannerItem: _ctx.plannerItem,
                tags: tags.value
              }, null, 8, ["plannerItem", "tags"]),
              (!_ctx.simplified)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (plannedEventDates.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref(t)("analytics.planner.planned_event_name")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_5, _toDisplayString(plannedEventDates.value), 1),
                    (actualEventDates.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(t)("analytics.planner.actual_event_name")), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(actualEventDates.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (
            _ctx.plannerItem.children &&
            _ctx.plannerItem.children.length === 0 &&
            plannerItemProgress.value.total_working_days !== plannerItemProgress.value.finished_working_days &&
            plannerItemProgress.value.total_working_days !== 0 &&
            plannerItemProgress.value.finished_working_days !== 0
          )
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "markAsDoneButton hidden items-center hover:underline truncate",
                    type: "button",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {
            isMarkAsDoneModalOpen.value = true;
            _unref(trackEvent)('progress_mark-completed_click');
          }, ["stop"]))
                  }, _toDisplayString(_unref(t)("analytics.planner.mark_as_done_modal.mark_as_done_button")), 1))
                : _createCommentVNode("", true),
              (endDateDeviationWd.value !== null && !_ctx.simplified)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 2,
                    class: _normalizeClass(["flex items-center ml-2", endDateDeviationWd.value >= 0 ? 'text-green-400' : 'text-red-400'])
                  }, _toDisplayString(endDateDeviationWd.value) + " " + _toDisplayString(_unref(t)("working_day.working_day_abbrev")), 3))
                : _createCommentVNode("", true),
              _createVNode(ProjectProgressItemDetail, {
                plannerItem: _ctx.plannerItem,
                plannerItemProgress: plannerItemProgress.value,
                simplified: _ctx.simplified,
                actualEventDates: actualEventDates.value,
                plannedEventDates: plannedEventDates.value,
                totalProgress: _ctx.totalProgress,
                tags: tags.value
              }, null, 8, ["plannerItem", "plannerItemProgress", "simplified", "actualEventDates", "plannedEventDates", "totalProgress", "tags"])
            ])
          ]),
          _: 2
        }, 1024),
        _createVNode(_unref(DisclosurePanel), null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plannerItem.children, (child) => {
                return (_openBlock(), _createBlock(_component_ProjectProgressItem, {
                  key: child._id,
                  plannerItem: child,
                  plannerItemProgressById: _ctx.plannerItemProgressById,
                  hierarchyTags: _ctx.hierarchyTags,
                  actualEventsBySourceId: _ctx.actualEventsBySourceId,
                  plannedEventsByPlannerId: _ctx.plannedEventsByPlannerId,
                  simplified: _ctx.simplified,
                  processesBySourceId: _ctx.processesBySourceId,
                  level: _ctx.level + 1,
                  parentDefaultOpen: isDefaultOpen.value,
                  childrenCountByLevel: _ctx.childrenCountByLevel,
                  tagsByPlannerItemId: _ctx.tagsByPlannerItemId,
                  projectDurationSettings: _ctx.projectDurationSettings,
                  totalProgress: _ctx.totalProgress
                }, null, 8, ["plannerItem", "plannerItemProgressById", "hierarchyTags", "actualEventsBySourceId", "plannedEventsByPlannerId", "simplified", "processesBySourceId", "level", "parentDefaultOpen", "childrenCountByLevel", "tagsByPlannerItemId", "projectDurationSettings", "totalProgress"]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["defaultOpen"]),
    (isMarkAsDoneModalOpen.value && actualEvent.value)
      ? (_openBlock(), _createBlock(MarkAsDoneModal, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (isMarkAsDoneModalOpen.value = false)),
          actualEventId: actualEvent.value._id,
          start: actualEvent.value.start,
          processes: _ctx.processesBySourceId[actualEvent.value.source_id] || [],
          tags: tags.value
        }, null, 8, ["actualEventId", "start", "processes", "tags"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})